import React from 'react'
import { Box, makeStyles, MenuItem, TextField } from '@material-ui/core'
import { changeLanguage } from 'i18next'
import { formatLanguage, i18n, Language } from '../../i18n'

const useStyles = makeStyles(() => ({
  container: {
    background: 'white',
    borderRadius: 4,
    width: '100%',
  },
}))

type Props = {
  afterChange: () => void
}

export function LanguageSwitcher({ afterChange }: Props): React.ReactElement {
  const classes = useStyles()
  const { language } = i18n

  return (
    <Box className={classes.container}>
      <TextField
        id="language-switcher"
        value={language}
        onChange={(event) => {
          void changeLanguage(event.target.value)
          afterChange()
        }}
        select
      >
        {Object.values(Language).map((lang) => (
          <MenuItem key={lang} value={lang}>
            {formatLanguage[lang]}
          </MenuItem>
        ))}
      </TextField>
    </Box>
  )
}
